import React, { useRef, useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Header from '../../includes/Header';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useFormik } from 'formik';
import { FaChevronUp, FaTrash } from "react-icons/fa";
import DateFild from '../../components/DateTimePicker/DateFild';
import TimeFild from '../../components/DateTimePicker/TimeFild';
import SelectFild from '../../components/SelectFild/SelectFild';
import UploadWithSignature from '../../components/UploadWithSignature/UploadWithSignature';
import { getRiskAsessment, getAircraftRegistrationMaster, getAircarftType, getPassengerImpactMainMaster, getPassengerImpactSubMaster, getProfile, postImageAnalyze, getSeverity, getLikeliHood, getDepartmentList, getCategoriesList, postGeneralForms } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { departmentValidationSchema, } from '../../schemas';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import utc from 'dayjs/plugin/utc';
import { $ } from 'react-jquery-plugin';
import maps from '../../assets/images/map.png';
import AircraftIncidentReport from '../AircraftIncidentReport/AircraftIncidentReport';

import VoiceInput from '../../components/VoiceInput/VoiceInput';

const NewCase = () => {
    const [selectdImg, setSelectdImg] = useState(null);
    const [preview, setPreview] = useState(null);
    const [isShowBtn, setShowBtn] = useState(false);
    const [isShowPopup, setShowPopup] = useState(false);
    const [reportData, setReportData] = useState([]);
    const reportRef = useRef();
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [severityList, setSeverityList] = useState([]);
    const [likeliHoods, setLikeliHoods] = useState([]);
    const [department, setDepartment] = useState([]);
    const [categoriesList, setCategoriesList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const mapRef = useRef(null);
    const searchInputRef = useRef(null);
    const [latLng, setLatLng] = useState({ lat: 24.961568, lng: 46.698799 });
    const [address, setAddress] = useState("");
    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState(null);
    const [geocoder, setGeocoder] = useState(null);
    const [localTime, setLocalTime] = useState(dayjs().format('HH:mm')); // Local Time
    const [utcTime, setUtcTime] = useState(dayjs().utc().format('HH:mm')); // UTC Time
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
    const [result, setResult] = useState('');
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [passengerImpactM, setPassengerImpactM] = useState([]);
    const [passengerImpactS, setPassengerImpactS] = useState([]);
    const [riskAsessmentColor, setRiskAsessmentColor] = useState([]);
    const [aircraftRegistration, setAircraftRegistration] = useState([]);
    const [aircraftTypes, setAircraftTypes] = useState([]);
    const navigate = useNavigate();
    const [editorReady, setEditorReady] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem('useToken')) {
            navigate("/home");
        }
    }, [navigate])

    useEffect(() => {
        $(document).on('click', '.toggle-button', function () {
            $(this).parent().toggleClass('opens');
        });
        return () => {
            $(document).off('click', '.toggle-button');
        };
    }, []);

    const getRiskAsessments = async () => {
        try {
            const res = await getRiskAsessment();
            setRiskAsessmentColor(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    const getDepartmentLists = async () => {
        try {
            const res = await getDepartmentList();
            setDepartment(res.data.data);
        } catch (error) {
        }
    };

    const getProfiles = async () => {
        try {
            const res = await getProfile();
            setData(res.data.data);
            const Mlat = res.data.data.latitude_deg;
            const Mlng = res.data.data.longitude_deg;
            const lat = parseFloat(Mlat) || 24.961568;
            const lng = parseFloat(Mlng) || 46.698799;
            setLatLng({ lat, lng });

        } catch (error) {
        }
    };

    const getSeveritys = async () => {
        try {
            const res = await getSeverity();
            setSeverityList(res.data.data);
        } catch (error) {
        }
    };

    const getLikeliHoods = async () => {
        try {
            const res = await getLikeliHood();
            setLikeliHoods(res.data.data);
        } catch (error) {
        }
    };

    const getCategoriesLists = async () => {
        try {
            const res = await getCategoriesList();
            setCategoriesList(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const getPassengerImpactMainMasters = async () => {
        try {
            const res = await getPassengerImpactMainMaster();
            setPassengerImpactM(res.data.data);
        } catch (error) {
        }
    };

    const getPassengerImpactSubMasters = async () => {
        try {
            const res = await getPassengerImpactSubMaster();
            setPassengerImpactS(res.data.data);
        } catch (error) {

        }
    };

    const getAircraftRegistrationMasters = async () => {
        try {
            const res = await getAircraftRegistrationMaster();
            setAircraftRegistration(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    const getAircarftTypes = async () => {
        try {
            const res = await getAircarftType();
            setAircraftTypes(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    useEffect(() => {
        getProfiles();
        getSeveritys();
        getLikeliHoods();
        getPassengerImpactMainMasters();
        getPassengerImpactSubMasters();
        getDepartmentLists();
        getCategoriesLists();
        getRiskAsessments();
        getAircraftRegistrationMasters();
        getAircarftTypes();
    }, []);

    useEffect(() => {
        if (showModal && window.google && window.google.maps) {
            initMap(latLng.lat, latLng.lng);
        }
    }, [showModal]);

    const initMap = (lat, lng) => {
        const position = { lat, lng };

        const gMap = new window.google.maps.Map(mapRef.current, {
            center: position,
            zoom: 15,
        });

        const gMarker = new window.google.maps.Marker({
            position,
            map: gMap,
            draggable: true,
        });

        const gGeocoder = new window.google.maps.Geocoder();

        gMarker.addListener("dragend", () => {
            const pos = gMarker.getPosition();
            updateLocation(pos.lat(), pos.lng(), gGeocoder);
        });

        // Setup Autocomplete
        const autocomplete = new window.google.maps.places.Autocomplete(
            searchInputRef.current,
            {
                types: ["geocode"], // or use: [] for all types
                fields: ["formatted_address", "geometry", "name"],
            }
        );
        autocomplete.bindTo("bounds", gMap);

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();

            if (!place.geometry || !place.geometry.location) {
                alert("No details available for input.");
                return;
            }

            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            setLatLng({ lat, lng });
            setAddress(place.formatted_address);

            gMap.setCenter({ lat, lng });
            gMap.setZoom(15);
            gMarker.setPosition({ lat, lng });

            localStorage.setItem("latitude", lat);
            localStorage.setItem("longitude", lng);
            localStorage.setItem("address", place.formatted_address);
        });

        setMap(gMap);
        setMarker(gMarker);
        setGeocoder(gGeocoder);
        updateLocation(lat, lng, gGeocoder);
    };

    const updateLocation = (lat, lng, gGeocoder = geocoder) => {
        setLatLng({ lat, lng });

        if (gGeocoder) {
            gGeocoder.geocode({ location: { lat, lng } }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setAddress(results[0].formatted_address);
                } else {
                    setAddress("No address found or Geocoder failed.");
                }
            });
        }
    };

    const handlePassengerImpChange = (id, isChecked) => {
        const currentValues = values.passengerImpactSubAs || [];
        let newValues;

        if (isChecked) {
            newValues = [...currentValues, id];
        } else {
            newValues = currentValues.filter(item => item !== id);
        }

        setFieldValue('passengerImpactSubAs', newValues);
    };

    const getDefaultUTCDate = () => {
        return dayjs().utc().format('DD/MM/YYYY');
    };

    const initialValues = {
        reportNumber: data?.reportNumber,
        airportName: data?.airpotname,
        airportCode: data?.icao_code,
        subIncidentArea: '',
        subExactCoordinates: '',
        incidentLat: latLng.lat?.toFixed(6),
        incidentLng: latLng.lng?.toFixed(6),
        incidentLocationHotspot: 'no',
        hotspotZone: '',
        previousIncidentReference: '',

        //When did it happen
        incidentDate: dayjs().format('DD/MM/YYYY'),
        incidentTime: localTime,
        utcTime: utcTime,
        utcDate: getDefaultUTCDate(),

        //What Occurred
        caseType: 'Incident',
        incidentClassification: 'Aviation Safety Event',
        severitys: 3,
        likeliHood: 3,

        //Description
        detailedImage: '',
        shortDescription: '',
        detailedDescription: result,
        immediateActionsTaken: '',
        reportedOn: dayjs().format('DD/MM/YYYY'),
        reportedBy: data?.Name,
        createdBy: data?.Name,

        //department
        notify_to: selectedDepartments,

        //department (AOCC)
        dPersonName: data?.Name,
        dActionTime: localTime,
        dActionTaken: '',
        dCommunicationLog: '',

        //department (HSSE)
        hPersonName: data?.Name,
        approvalTime: localTime,
        initialAssessment: '',
        recommendations: '',
        closureApproval: '',

        //department (AIRSIDE)
        leadOfficer: data?.Name,
        actionTime: localTime,
        actionTaken: '',

        //department (FIRE)
        fireCommanderName: data?.Name,
        fireCategoryIncidentCode: '',
        unitDispatched: '',
        unitArrivalTime: localTime,
        fActionTaken: '',


        //department (Terminal)
        terminalSupervisoronDuty: data?.Name,
        terminalEvacuationRequired: 'no',
        tActionTime: localTime,
        passengerImpactAs: '',
        passengerImpactSubAs: [],
        crowdControlActions: 'yes',

        //department (ENGINEERING)
        ePersonName: data?.Name,
        eActionTime: localTime,
        eOccurrenceType: '',
        eLocation: '',
        eOtherOccurrenceType: '',
        eOtherLocation: '',
        eSupervisorManagerNotified: '',
        eFollowupRequired: '',
        eActionTaken: '',

        //department (OTHERS)
        othersPersonname: data?.Name,
        othersActionTime: localTime,
        othersSpecifyDepartment: '',
        othersOccurrenceType: '',
        othersDetails: '',
        othersLocation: '',
        othersActionTaken: '',

        //department (AIRLINE)

        airlinePersonName: data?.Name,
        airlineCode: '',
        airlineFlightNumber: '',
        airlineAircraftType: '',
        airlineArrivalTime: localTime,
        airlineDepartureTime: localTime,
        airlineGateNumber: '',
        airlineNumberofPassengers: '',
        airlineDelayReason: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: departmentValidationSchema(data.departmentname),
        onSubmit: async (values) => {
            setLoadings(true);
            const departmentData = getDepartmentData(values, data.departmentname);

            const formData = new FormData();
            formData.append('department_id', data?.department_id);
            formData.append('report_number', data?.reportNumber);
            formData.append('airport_name', data?.airpotname);
            formData.append('airport_code', data?.icao_code);
            formData.append('airport_mapping_id', data.airport_mapping_id);
            formData.append('incident_area', values.subIncidentArea);
            formData.append('exact_coordinates', values.subExactCoordinates);
            formData.append('incident_lat', latLng.lat?.toFixed(6));
            formData.append('incident_lng', latLng.lng?.toFixed(6));
            formData.append('incident_location_hotspot', values.incidentLocationHotspot);
            if (values.incidentLocationHotspot === 'yes') {
                formData.append('hotspot_zone', values.hotspotZone);
                formData.append('previous_incident_reference', values.previousIncidentReference);
            }
            formData.append('incident_date', values.incidentDate);
            formData.append('incident_time', values.incidentTime);
            formData.append('utc_date', values.utcDate);
            formData.append('utc_time', values.utcTime);
            formData.append('case_type', values.caseType);
            formData.append('incident_classification', values.incidentClassification);
            formData.append('severity_level', values.severitys);
            formData.append('likelihood', values.likeliHood);
            formData.append('status', 1);
            formData.append('category_data', JSON.stringify(selectedCheckboxes));
            formData.append('images[]', selectdImg);
            formData.append('short_description', values.shortDescription);
            formData.append('incident_detail_description', values.detailedDescription);
            formData.append('immediate_action_taken', values.immediateActionsTaken);
            formData.append('reported_on', values.reportedOn);
            formData.append('reported_by', values.reportedBy);
            formData.append('created_by', values.createdBy);
            formData.append('notify_to', JSON.stringify(selectedDepartments));
            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)
                if (file.originalFile.type === 'application/pdf') {
                    formData.append('department_image[]', file.originalFile);
                }
                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('department_image[]', blob, `signature_${file.originalFile.name}`);
                }
            });
            formData.append('data_fields', JSON.stringify(departmentData));
            formData.append('who', JSON.stringify(reportData?.fiveWAnalysis?.data?.whoInvolved));
            formData.append('why', JSON.stringify(reportData?.fiveWAnalysis?.data?.why));
            formData.append('What', reportData?.fiveWAnalysis?.data?.whatHappened);
            formData.append('Where', reportData?.fiveWAnalysis?.data?.where);
            formData.append('When', reportData?.fiveWAnalysis?.data?.when);
            formData.append('safety_standards_referenced', JSON.stringify(reportData?.standards_referenced?.description));
            formData.append('LessonsLearned', reportData?.lessons_learned?.description);
            formData.append('RealLifeParallelExample', reportData?.real_life_example?.description);
            formData.append('RiskMatrix', JSON.stringify(reportData?.risk_matrix?.data));
            formData.append('CorrectiveActionPlan', JSON.stringify(reportData?.corrective_action_plan?.data));

            try {
                const res = await postGeneralForms(formData);
                toast.success(res.data.message);
                setLoadings(false);
                setTimeout(() => navigate("/home"), 3000);
                //resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }

            console.log('formData', formData);
            console.log('reportDataMod', reportData);
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    useEffect(() => {
        setFieldValue('incidentLat', latLng.lat?.toFixed(6));
        setFieldValue('incidentLng', latLng.lng?.toFixed(6));
        setFieldValue('subExactCoordinates', latLng.lat != null && latLng.lng != null
            ? `${latLng.lat?.toFixed(6)}, ${latLng.lng?.toFixed(6)}`
            : '');
        setFieldValue('createdBy', data?.Name);
        setFieldValue('reportedBy', data?.Name);

        setFieldValue('dPersonName', data?.Name);
        setFieldValue('hPersonName', data?.Name);
        setFieldValue('leadOfficer', data?.Name);
        setFieldValue('fireCommanderName', data?.Name);
        setFieldValue('terminalSupervisoronDuty', data?.Name);
        setFieldValue('ePersonName', data?.Name);
        setFieldValue('othersPersonname', data?.Name);
        setFieldValue('airlinePersonName', data?.Name);

    }, [latLng, setFieldValue]);

    const base64ToBlob = (base64) => {
        const arr = base64.split(',');
        const mime = arr[0].match(/:(.*?);/)?.[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    // Your existing function to convert a file/blob to JPEG
    const convertToJpeg = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob(
                        (blob) => {
                            if (blob) resolve(blob);
                            else reject(new Error("Canvas toBlob failed"));
                        },
                        "image/jpeg",
                        0.9 // quality
                    );
                };
            };
            reader.onerror = (error) => reject(error);
        });
    };

    useEffect(() => {
        const getLocalStorageItem = (key) => {
            try {
                return localStorage.getItem(key);
            } catch (e) {
                console.error("Error getting localStorage item:", e);
                return null;
            }
        };


        const loadStoredImage = async () => {
            try {
                const file = getLocalStorageItem('homeModalImage');

                if (!file) return;

                let fileObject;

                try {
                    const initialBlob = base64ToBlob(file);
                    const jpgBlob = await convertToJpeg(initialBlob);

                    const filename = `uploaded_image_${Date.now()}.jpeg`;
                    fileObject = new File([jpgBlob], filename, { type: 'image/jpeg' });
                    setPreview(file);
                    setSelectdImg(fileObject);
                    setFieldValue('detailedImage', 1);

                } catch (error) {
                    console.error("Error processing image:", error);
                }

                setLoadings(true);
                const res = await getProfile();
                setData(res.data.data);

                const Mlat = res.data.data.latitude_deg;
                const Mlng = res.data.data.longitude_deg;
                const lat = parseFloat(Mlat) || 24.961568;
                const lng = parseFloat(Mlng) || 46.698799;
                setLatLng({ lat, lng });

                const formData = new FormData();
                formData.append('airportname', res.data.data.airpotname);
                formData.append('localdate', values.incidentDate);
                formData.append('localtime', localTime);
                formData.append('ICAOcode', res.data.data.icao_code);
                formData.append('image[]', fileObject);

                try {
                    const rs = await postImageAnalyze(formData);
                    setReportData(rs.data.data);
                    toast.success('AI Safety Genie Analyzes data get successfully');
                    setShowPopup(true);
                    setShowBtn(true);
                    localStorage.removeItem('homeModalImage');
                } catch (error) {
                    toast.error(error?.response?.data?.message);
                    console.error(error);
                } finally {
                    setLoadings(false);
                }

            } catch (error) {
                console.error('Error loading stored image from IndexedDB:', error);
            }
        };

        loadStoredImage();
    }, []);

    const getDepartmentData = (values, department) => {
        const departmentFields = {
            AOCC: ['dPersonName', 'dActionTime', 'dActionTaken', 'dCommunicationLog'],
            HSSE: ['hPersonName', 'approvalTime', 'initialAssessment', 'recommendations', 'closureApproval'],
            AIRSIDE: ['leadOfficer', 'actionTime', 'actionTaken'],
            FIRE: ['fireCommanderName', 'fireCategoryIncidentCode', 'unitDispatched', 'unitArrivalTime', 'fActionTaken'],
            TERMINAL: ['terminalSupervisoronDuty', 'terminalEvacuationRequired', 'tActionTime', 'passengerImpactAs', 'passengerImpactSubAs', 'crowdControlActions'],
            ENGINEERING: ['ePersonName', 'eActionTime', 'eOccurrenceType', 'eLocation', 'eOtherOccurrenceType', 'eOtherLocation', 'eSupervisorManagerNotified', 'eFollowupRequired', 'eActionTaken'],
            OTHERS: ['othersPersonname', 'othersSpecifyDepartment', 'othersActionTime', 'othersOccurrenceType', 'othersDetails', 'othersLocation', 'othersActionTaken'],
            AIRLINE: ['airlinePersonName', 'airlineCode', 'airlineFlightNumber', 'airlineAircraftType', 'airlineArrivalTime', 'airlineDepartureTime', 'airlineGateNumber', 'airlineNumberofPassengers', 'airlineDelayReason']
        };

        return departmentFields[department].reduce((acc, field) => {
            acc[field] = values[field];
            return acc;
        }, {});
    };

    const handleCheckboxChange = (categoryId, subCategoryId, isChecked) => {
        setSelectedCheckboxes(prev => {
            const current = prev[categoryId] || [];

            if (isChecked) {
                return {
                    ...prev,
                    [categoryId]: [...current, subCategoryId]
                };
            } else {
                const updated = current.filter(id => id !== subCategoryId);
                const newState = { ...prev, [categoryId]: updated };
                // Remove category if no subcategories selected
                if (updated.length === 0) {
                    delete newState[categoryId];
                }
                return newState;
            }
        });
    };

    const handleDepartmentsChange = (id, isChecked) => {
        if (isChecked) {
            setSelectedDepartments((prev) => [...prev, id]);
        } else {
            setSelectedDepartments((prev) => prev.filter((deptId) => deptId !== id));
        }
    };



    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
                setFieldValue('detailedImage', 1);
            };
            reader.readAsDataURL(file);

            try {
                const jpgBlob = await convertToJpeg(file);
                const filename = `uploaded_image_${Date.now()}.jpeg`;
                const fileObject = new File([jpgBlob], filename, { type: 'image/jpeg' });
                setSelectdImg(fileObject);
            } catch (error) {
                console.error("Error processing image:", error);
            }
        }
        e.target.value = null;
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
                setFieldValue('detailedImage', 1);
            };
            reader.readAsDataURL(file);

            try {
                const jpgBlob = await convertToJpeg(file);
                const filename = `uploaded_image_${Date.now()}.jpeg`;
                const fileObject = new File([jpgBlob], filename, { type: 'image/jpeg' });
                setSelectdImg(fileObject);
            } catch (error) {
                console.error("Error processing image:", error);
            }
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleRemoveImage = () => {
        setSelectdImg(null);
        setPreview(null);
        setFieldValue('detailedImage', '');
    };


    const analyzeImage = async () => {
        if (!selectdImg) {
            toast.error('Please select an image first');
            return;
        }
        const formData = new FormData();
        formData.append('airportname', data?.airpotname);
        formData.append('localdate', values.incidentDate);
        formData.append('localtime', localTime);
        formData.append('ICAOcode', data?.icao_code);
        formData.append('image[]', selectdImg);

        try {
            setLoadings(true);
            const res = await postImageAnalyze(formData);
            setReportData(res.data.data);
            toast.success('AI Safety Genie Analyzes data get successfully');
            setShowPopup(true);
            setShowBtn(true);
        } catch (error) {
            console.error('API Error:', error);
            console.error('Error Response:', error.response);
            toast.error(error?.response?.data?.message || "Error analyzing image");
        } finally {
            setLoadings(false);
        }
    };

    useEffect(() => {
        setFieldValue('detailedDescription', reportData?.image_analysis?.description || '');
        setFieldValue('shortDescription', reportData?.short_description?.description || '');
        setFieldValue('immediateActionsTaken', reportData?.immediate_actions_taken?.description || '');
        setEditorReady(true);
    }, [reportData, setFieldValue]);


    const handleSaveAndClose = () => {
        if (reportRef.current) {
            const success = reportRef.current.handleSave();
            if (success) {
                setShowBtn(true);
                setShowPopup(false);
            }
        }
    };

    return (
        <>
            <Header />
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            <section id="forms">
                <div className="forms-block">
                    {isLoading ? <Loader /> :
                        <Container>
                            <div className="form-box">
                                <form onSubmit={handleSubmit} autoComplete="off">
                                    <div className="fieldset">
                                        <h1>Where did it take place</h1>
                                        <div className="formsBox">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Report Number</label>
                                                        <input type="text"
                                                            id="reportNumber"
                                                            name="reportNumber"
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={data?.reportNumber}
                                                            readOnly={true}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Airport Name</label>
                                                        <input type="text"
                                                            id="airportName"
                                                            name="airportName"
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={data?.airpotname}
                                                            readOnly={true}
                                                        />
                                                        {errors.airportName && touched.airportName ? (
                                                            <p className='errormsg'>{errors.airportName}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>ICAO Code</label>
                                                        <input type="text"
                                                            id="airportCode"
                                                            name="airportCode"
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={data?.icao_code}
                                                            readOnly={true}
                                                        />
                                                        {errors.airportCode && touched.airportCode ? (
                                                            <p className='errormsg'>{errors.airportCode}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group io">
                                                        <label>Location</label>
                                                        <input type="text"
                                                            id="subExactCoordinates"
                                                            name="subExactCoordinates"
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={values.subExactCoordinates}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        <Link onClick={() => setShowModal(true)}><img src={maps} alt='Map' title='Map' /></Link>
                                                        {errors.subExactCoordinates && touched.subExactCoordinates ? (
                                                            <p className='errormsg'>{errors.subExactCoordinates}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Exact Location</label>
                                                        <input type="text"
                                                            id="subIncidentArea"
                                                            name="subIncidentArea"
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={values.subIncidentArea}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.subIncidentArea && touched.subIncidentArea ? (
                                                            <p className='errormsg'>{errors.subIncidentArea}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Is Incident Location a Known Hotspot?</label>
                                                        <select
                                                            id="incidentLocationHotspot"
                                                            name='incidentLocationHotspot'
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={values.incidentLocationHotspot}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        >
                                                            <option value="no">No</option>
                                                            <option value="yes">Yes</option>
                                                        </select>
                                                        {errors.incidentLocationHotspot && touched.incidentLocationHotspot && (
                                                            <p className="errormsg">{errors.incidentLocationHotspot}</p>
                                                        )}
                                                    </div>
                                                </Col>
                                                {values.incidentLocationHotspot == 'yes' && (
                                                    <>
                                                        <Col md={4}>
                                                            <div className="form-group io">
                                                                <label>Hotspot Zone Identifier (Code/Area)</label>
                                                                <input type="text"
                                                                    id="hotspotZone"
                                                                    name="hotspotZone"
                                                                    className="form-control"
                                                                    autoComplete='off'
                                                                    value={values.hotspotZone}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                {errors.hotspotZone && touched.hotspotZone ? (
                                                                    <p className='errormsg'>{errors.hotspotZone}</p>
                                                                ) : null}
                                                            </div>
                                                        </Col>
                                                        <Col md={4}>
                                                            <div className="form-group io">
                                                                <label>Provide Previous Incident References or Frequency</label>
                                                                <input type="text"
                                                                    id="previousIncidentReference"
                                                                    name="previousIncidentReference"
                                                                    className="form-control"
                                                                    autoComplete='off'
                                                                    value={values.previousIncidentReference}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                {errors.previousIncidentReference && touched.previousIncidentReference ? (
                                                                    <p className='errormsg'>{errors.previousIncidentReference}</p>
                                                                ) : null}
                                                            </div>
                                                        </Col>
                                                    </>
                                                )}
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="fieldset">
                                        <h1>When did it happen</h1>
                                        <div className="formsBox">
                                            <Row>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label>Local Date (DD/MM/YYYY)</label>
                                                        <DateFild
                                                            value={values.incidentDate}
                                                            onChange={(date) => setFieldValue('incidentDate', date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label>Local Time</label>
                                                        <TimeFild
                                                            value={localTime}
                                                            onChange={setLocalTime}
                                                            format="local"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label>UTC Date (DD/MM/YYYY)</label>
                                                        <DateFild
                                                            value={values.utcDate}
                                                            onChange={(date) => setFieldValue('utcDate', date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label>UTC Time</label>
                                                        <TimeFild
                                                            value={utcTime}
                                                            onChange={setUtcTime}
                                                            format="utc"
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="GroupList fieldset">
                                        <div className='toggle-button'>
                                            <h2 className="listTitle">What Occurred</h2>
                                            <div className='btnColaps'><FaChevronUp /></div>
                                        </div>
                                        <div className="formsBox subFilds">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Case Type</label>
                                                        <div className="radiogroups">
                                                            {["Incident", "Accident"].map(
                                                                (option) => (
                                                                    <div className="radiobox" key={option}>
                                                                        <label>
                                                                            {option}
                                                                            <input
                                                                                type="radio"
                                                                                name="caseType"
                                                                                value={option}
                                                                                checked={values.caseType === option}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="radiogroups">
                                                            {["Aviation Safety Event", "HSSE Event"].map(
                                                                (option) => (
                                                                    <div className="radiobox" key={option}>
                                                                        <label>
                                                                            {option}
                                                                            <input
                                                                                type="radio"
                                                                                name="incidentClassification"
                                                                                value={option}
                                                                                checked={values.incidentClassification === option}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Severity Level (as per ICAO / NEBOSH)</label>
                                                        <SelectFild
                                                            Firstop='Select Severity Level'
                                                            selectName="severitys"
                                                            options={severityList}
                                                            value={values.severitys}
                                                            onChange={(selectedOption) => setFieldValue("severitys", selectedOption?.value || "")}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.severitys && touched.severitys && (
                                                            <p className="errormsg">{errors.severitys}</p>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Likelihood</label>
                                                        <SelectFild
                                                            Firstop='Select likeliHood'
                                                            selectName="likeliHood"
                                                            options={likeliHoods}
                                                            value={values.likeliHood}
                                                            onChange={(selectedOption) => setFieldValue("likeliHood", selectedOption?.value || "")}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.likeliHood && touched.likeliHood && (
                                                            <p className="errormsg">{errors.likeliHood}</p>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div id={values.incidentClassification == 'HSSE Event' ? 'hsseList' : 'aviationList'} className='formslistsData'>
                                                {categoriesList.map((item) => (
                                                    <div className={item.id === 1 ? 'checklists' : 'checklists grid'} key={item.id}
                                                        style={item.event_type == values.incidentClassification ? { display: 'block' } : { display: 'none' }}
                                                    >
                                                        <h4>{item.category_name}</h4>
                                                        <div className={item.id === 1 ? 'mainTypeList chkgroup' : 'chkgroup'}>
                                                            {item.incidentsubcategory.map((sublist) => {
                                                                const isChecked = selectedCheckboxes[item.id]?.includes(sublist.id) || false;
                                                                return (
                                                                    <div className="chekbox" key={sublist.id}>
                                                                        <label>
                                                                            {sublist.sub_category_name}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={sublist.id}
                                                                                checked={isChecked}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange(item.id, sublist.id, e.target.checked)
                                                                                }
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="GroupList fieldset">
                                        <div className='toggle-button'>
                                            <h2 className="listTitle">Action to be taken by Other Departments too</h2>
                                            <div className='btnColaps'><FaChevronUp /></div>
                                        </div>
                                        <div className='subFilds'>
                                            <div className="form-group">
                                                <label>Notify to</label>
                                                <div className="chkgroup">
                                                    {department.map((item) => {
                                                        if (item.id === data.department_id) return null;
                                                        if (item.name === 'HSSE') return null;// skip rendering
                                                        return (
                                                            <div className={`chekbox ${item.name}`} key={item.id}>
                                                                <label>
                                                                    {item.name}
                                                                    <input
                                                                        type="checkbox"
                                                                        value={item.id}
                                                                        checked={selectedDepartments.includes(item.id)}
                                                                        onChange={(e) =>
                                                                            handleDepartmentsChange(item.id, e.target.checked)
                                                                        }
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            <div id="AOCC" className="department" style={data.departmentname === 'AOCC' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1><span>AOCC</span></h1>
                                                    <div className='formsBox'>
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Person Name</label>
                                                                    <input
                                                                        type='text'
                                                                        id="dPersonName"
                                                                        name="dPersonName"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={values.dPersonName}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.dPersonName && touched.dPersonName ? (
                                                                        <p className='errormsg'>{errors.dPersonName}</p>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Time</label>
                                                                    <TimeFild
                                                                        value={values.dActionTime}
                                                                        onChange={(time) => setFieldValue('dActionTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.dActionTime && touched.dActionTime ? (
                                                                        <p className='errormsg'>{errors.dActionTime}</p>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Taken</label>
                                                                    <input
                                                                        type='text'
                                                                        id="dActionTaken"
                                                                        name="dActionTaken"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={values.dActionTaken}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.dActionTaken && touched.dActionTaken ? (
                                                                        <p className='errormsg'>{errors.dActionTaken}</p>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Communication Log</label>
                                                                    <input
                                                                        type='text'
                                                                        id="dCommunicationLog"
                                                                        name="dCommunicationLog"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={values.dCommunicationLog}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.dCommunicationLog && touched.dCommunicationLog ? (
                                                                        <p className='errormsg'>{errors.dCommunicationLog}</p>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="HSSE" className="department" style={data.departmentname === 'HSSE' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1>HSSE</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Person Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="hPersonName"
                                                                        name="hPersonName"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.hPersonName}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.hPersonName && touched.hPersonName && (
                                                                        <p className="errormsg">{errors.hPersonName}</p>
                                                                    )}
                                                                </div>
                                                            </Col>

                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Approval Time</label>
                                                                    <TimeFild
                                                                        value={values.approvalTime}
                                                                        onChange={(time) => setFieldValue('approvalTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.approvalTime && touched.approvalTime && (
                                                                        <p className="errormsg">{errors.approvalTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>

                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Initial Assessment</label>
                                                                    <textarea
                                                                        id="initialAssessment"
                                                                        name="initialAssessment"
                                                                        className="form-control"
                                                                        value={values.initialAssessment}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.initialAssessment && touched.initialAssessment && (
                                                                        <p className="errormsg">{errors.initialAssessment}</p>
                                                                    )}
                                                                </div>
                                                            </Col>

                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Recommendations</label>
                                                                    <textarea
                                                                        id="recommendations"
                                                                        name="recommendations"
                                                                        className="form-control"
                                                                        value={values.recommendations}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.recommendations && touched.recommendations && (
                                                                        <p className="errormsg">{errors.recommendations}</p>
                                                                    )}
                                                                </div>
                                                            </Col>

                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Closure Approval</label>
                                                                    <textarea
                                                                        id="closureApproval"
                                                                        name="closureApproval"
                                                                        className="form-control"
                                                                        value={values.closureApproval}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.closureApproval && touched.closureApproval && (
                                                                        <p className="errormsg">{errors.closureApproval}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="AIRSIDE" className="department" style={data.departmentname === 'AIRSIDE' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1>AIRSIDE</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Lead Officer</label>
                                                                    <input
                                                                        type="text"
                                                                        id="leadOfficer"
                                                                        name="leadOfficer"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.leadOfficer}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.leadOfficer && touched.leadOfficer && (
                                                                        <p className="errormsg">{errors.leadOfficer}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Time</label>
                                                                    <TimeFild
                                                                        value={values.actionTime}
                                                                        onChange={(time) => setFieldValue('actionTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.actionTime && touched.actionTime && (
                                                                        <p className="errormsg">{errors.actionTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Taken</label>
                                                                    <textarea
                                                                        id="actionTaken"
                                                                        name="actionTaken"
                                                                        className="form-control"
                                                                        value={values.actionTaken}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.actionTaken && touched.actionTaken && (
                                                                        <p className="errormsg">{errors.actionTaken}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="FIRE" className="department" style={data.departmentname === 'FIRE' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1>FIRE</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Fire Commander Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="fireCommanderName"
                                                                        name="fireCommanderName"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.fireCommanderName}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.fireCommanderName && touched.fireCommanderName && (
                                                                        <p className="errormsg">{errors.fireCommanderName}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Fire Category Incident Code</label>
                                                                    <SelectFild
                                                                        Firstop='Select Fire Category Incident Code'
                                                                        selectName="fireCategoryIncidentCode"
                                                                        options={[
                                                                            { name: 'CAT 1', id: '1' },
                                                                            { name: 'CAT 2', id: '2' },
                                                                            { name: 'CAT 3', id: '3' },
                                                                            { name: 'CAT 4', id: '4' },
                                                                            { name: 'CAT 5', id: '5' },
                                                                            { name: 'CAT 6', id: '6' },
                                                                            { name: 'CAT 7', id: '7' },
                                                                            { name: 'CAT 8', id: '8' },
                                                                            { name: 'CAT 9', id: '9' },
                                                                            { name: 'CAT 10', id: '10' },
                                                                        ]}
                                                                        value={values.fireCategoryIncidentCode}
                                                                        onChange={(selectedOption) => setFieldValue("fireCategoryIncidentCode", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.fireCategoryIncidentCode && touched.fireCategoryIncidentCode && (
                                                                        <p className="errormsg">{errors.fireCategoryIncidentCode}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Unit Dispatched</label>
                                                                    <input
                                                                        type="text"
                                                                        id="unitDispatched"
                                                                        name="unitDispatched"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.unitDispatched}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.unitDispatched && touched.unitDispatched && (
                                                                        <p className="errormsg">{errors.unitDispatched}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Unit Arrival Time</label>
                                                                    <TimeFild
                                                                        value={values.unitArrivalTime}
                                                                        onChange={(time) => setFieldValue('unitArrivalTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.unitArrivalTime && touched.unitArrivalTime && (
                                                                        <p className="errormsg">{errors.unitArrivalTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Taken</label>
                                                                    <textarea
                                                                        id="fActionTaken"
                                                                        name="fActionTaken"
                                                                        className="form-control"
                                                                        value={values.fActionTaken}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.fActionTaken && touched.fActionTaken && (
                                                                        <p className="errormsg">{errors.fActionTaken}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="TERMINAL" className="department" style={data.departmentname === 'TERMINAL' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1>TERMINAL</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Terminal Supervisor on Duty</label>
                                                                    <input
                                                                        type="text"
                                                                        id="terminalSupervisoronDuty"
                                                                        name="terminalSupervisoronDuty"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.terminalSupervisoronDuty}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.terminalSupervisoronDuty && touched.terminalSupervisoronDuty && (
                                                                        <p className="errormsg">{errors.terminalSupervisoronDuty}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Terminal Evacuation Required?</label>
                                                                    <SelectFild
                                                                        Firstop='Select Terminal Evacuation Required?'
                                                                        selectName="terminalEvacuationRequired"
                                                                        options={[
                                                                            { name: 'Yes', id: 'yes' },
                                                                            { name: 'No', id: 'no' },
                                                                        ]}
                                                                        value={values.terminalEvacuationRequired}
                                                                        onChange={(selectedOption) => setFieldValue("terminalEvacuationRequired", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />

                                                                    {errors.terminalEvacuationRequired && touched.terminalEvacuationRequired && (
                                                                        <p className="errormsg">{errors.terminalEvacuationRequired}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Time</label>
                                                                    <TimeFild
                                                                        value={values.tActionTime}
                                                                        onChange={(time) => setFieldValue('tActionTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.tActionTime && touched.tActionTime && (
                                                                        <p className="errormsg">{errors.tActionTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Passenger Impact Assessment</label>
                                                                    <SelectFild
                                                                        Firstop="Select Passenger Impact Assessment"
                                                                        selectName='passengerImpactAs'
                                                                        options={passengerImpactM}
                                                                        value={values.passengerImpactAs}
                                                                        onChange={(selectedOption) => setFieldValue("passengerImpactAs", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.passengerImpactAs && touched.passengerImpactAs && (
                                                                        <p className="errormsg">{errors.passengerImpactAs}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Passenger Impact Sub Assessment</label>
                                                                    <div className="chkgroup">
                                                                        {(passengerImpactS || []).map((item) => (
                                                                            <div className="chekbox" key={item.id}>
                                                                                <label>
                                                                                    {item.name}
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        value={item.id}
                                                                                        checked={(values.passengerImpactSubAs || []).includes(item.id)}
                                                                                        onChange={(e) => handlePassengerImpChange(item.id, e.target.checked)}
                                                                                    />
                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    {errors.passengerImpactSubAs && touched.passengerImpactSubAs && (
                                                                        <p className="errormsg">{errors.passengerImpactSubAs}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Crowd Control Actions</label>
                                                                    <textarea
                                                                        id="crowdControlActions"
                                                                        name="crowdControlActions"
                                                                        className="form-control"
                                                                        value={values.crowdControlActions}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.crowdControlActions && touched.crowdControlActions && (
                                                                        <p className="errormsg">{errors.crowdControlActions}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="ENGINEERING" className="department" style={data.departmentname === 'ENGINEERING' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1>ENGINEERING</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Person Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="ePersonName"
                                                                        name="ePersonName"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.ePersonName}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.ePersonName && touched.ePersonName && (
                                                                        <p className="errormsg">{errors.ePersonName}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Time</label>
                                                                    <TimeFild
                                                                        value={values.eActionTime}
                                                                        onChange={(time) => setFieldValue('eActionTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.eActionTime && touched.eActionTime && (
                                                                        <p className="errormsg">{errors.eActionTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Occurrence Type</label>
                                                                    <SelectFild
                                                                        Firstop='Select Occurrence Type'
                                                                        selectName="eOccurrenceType"
                                                                        options={[
                                                                            { name: 'Equipment Failure', id: 'Equipment Failure' },
                                                                            { name: 'Infrastructure Damage', id: 'Infrastructure Damage' },
                                                                            { name: 'Electrical Hazard', id: 'Electrical Hazard' },
                                                                            { name: 'Mechanical Fault', id: 'Mechanical Fault' },
                                                                            { name: 'Other', id: 'Other' },
                                                                        ]}
                                                                        value={values.eOccurrenceType}
                                                                        onChange={(selectedOption) => setFieldValue("eOccurrenceType", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.eOccurrenceType && touched.eOccurrenceType && (
                                                                        <p className="errormsg">{errors.eOccurrenceType}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>eLocation</label>
                                                                    <SelectFild
                                                                        Firstop='Select Location'
                                                                        selectName="eLocation"
                                                                        options={[
                                                                            { name: 'Airside', id: 'Airside' },
                                                                            { name: 'Terminal', id: 'Terminal' },
                                                                            { name: 'Landside', id: 'Landside' },
                                                                            { name: 'Apron', id: 'Apron' },
                                                                            { name: 'Runway', id: 'Runway' },
                                                                            { name: 'Taxiway', id: 'Taxiway' },
                                                                            { name: 'Ramp', id: 'Ramp' },
                                                                            { name: 'Workshop', id: 'Workshop' },
                                                                            { name: 'Hangar', id: 'Hangar' },
                                                                            { name: 'Cargo Area', id: 'Cargo Area' },
                                                                            { name: 'Baggage Handling Area', id: 'Baggage Handling Area' },
                                                                            { name: 'Passenger Gate / Boarding Gate', id: 'Passenger Gate / Boarding Gate' },
                                                                            { name: 'Security Checkpoint', id: 'Security Checkpoint' },
                                                                            { name: 'Control Tower / Operations Center', id: 'Control Tower / Operations Center' },
                                                                            { name: 'Fuel Farm / Refueling Area', id: 'Fuel Farm / Refueling Area' },
                                                                            { name: 'Fire Station / Emergency Services', id: 'Fire Station / Emergency Services' },
                                                                            { name: 'Car Park / Parking Lot', id: 'Car Park / Parking Lot' },
                                                                            { name: 'Access Road / Perimeter Road', id: 'Access Road / Perimeter Road' },
                                                                            { name: 'Administrative Offices', id: 'Administrative Offices' },
                                                                            { name: 'Retail / Concessions Area', id: 'Retail / Concessions Area' },
                                                                            { name: 'Customs / Immigration', id: 'Customs / Immigration' },
                                                                            { name: 'VIP / Executive Lounge', id: 'VIP / Executive Lounge' },
                                                                            { name: 'Bus / Shuttle Zone', id: 'Bus / Shuttle Zone' },
                                                                            { name: 'Waste Management Area', id: 'Waste Management Area' },
                                                                            { name: 'Other', id: 'Other' },
                                                                        ]}
                                                                        value={values.eLocation}
                                                                        onChange={(selectedOption) => setFieldValue("eLocation", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.eLocation && touched.eLocation && (
                                                                        <p className="errormsg">{errors.eLocation}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            {values.eOccurrenceType === 'Other' && (
                                                                <Col md={6}>
                                                                    <div className="form-group">
                                                                        <label>Other Occurrence Type</label>
                                                                        <textarea
                                                                            id="eOtherOccurrenceType"
                                                                            name="eOtherOccurrenceType"
                                                                            className="form-control"
                                                                            value={values.eOtherOccurrenceType}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {errors.eOtherOccurrenceType && touched.eOtherOccurrenceType && (
                                                                            <p className="errormsg">{errors.eOtherOccurrenceType}</p>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            )}
                                                            {values.eLocation === 'Other' && (
                                                                <Col md={6}>
                                                                    <div className="form-group">
                                                                        <label>Other Location</label>
                                                                        <textarea
                                                                            id="eOtherLocation"
                                                                            name="eOtherLocation"
                                                                            className="form-control"
                                                                            value={values.eOtherLocation}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {errors.eOtherLocation && touched.eOtherLocation && (
                                                                            <p className="errormsg">{errors.eOtherLocation}</p>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            )}
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Supervisor/Manager Notified</label>
                                                                    <input
                                                                        type="text"
                                                                        id="eSupervisorManagerNotified"
                                                                        name="eSupervisorManagerNotified"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.eSupervisorManagerNotified}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.eSupervisorManagerNotified && touched.eSupervisorManagerNotified && (
                                                                        <p className="errormsg">{errors.eSupervisorManagerNotified}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Follow-up Required</label>
                                                                    <SelectFild
                                                                        Firstop='Select Follow-up Required'
                                                                        selectName="eFollowupRequired"
                                                                        options={[
                                                                            { name: 'Yes', id: 'yes' },
                                                                            { name: 'No', id: 'no' },
                                                                        ]}
                                                                        value={values.eFollowupRequired}
                                                                        onChange={(selectedOption) => setFieldValue("eFollowupRequired", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.eFollowupRequired && touched.eFollowupRequired && (
                                                                        <p className="errormsg">{errors.eFollowupRequired}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Taken</label>
                                                                    <textarea
                                                                        id="eActionTaken"
                                                                        name="eActionTaken"
                                                                        className="form-control"
                                                                        value={values.eActionTaken}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.eActionTaken && touched.eActionTaken && (
                                                                        <p className="errormsg">{errors.eActionTaken}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="OTHERS" className="department" style={data.departmentname === 'OTHERS' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1>OTHERS</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Person name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="othersPersonname"
                                                                        name="othersPersonname"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.othersPersonname}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.othersPersonname && touched.othersPersonname && (
                                                                        <p className="errormsg">{errors.othersPersonname}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Specify Department</label>
                                                                    <input
                                                                        type="text"
                                                                        id="othersSpecifyDepartment"
                                                                        name="othersSpecifyDepartment"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.othersSpecifyDepartment}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.othersSpecifyDepartment && touched.othersSpecifyDepartment && (
                                                                        <p className="errormsg">{errors.othersSpecifyDepartment}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Time</label>
                                                                    <TimeFild
                                                                        value={values.othersActionTime}
                                                                        onChange={(time) => setFieldValue('othersActionTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.othersActionTime && touched.othersActionTime && (
                                                                        <p className="errormsg">{errors.othersActionTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Occurrence Type</label>
                                                                    <SelectFild
                                                                        Firstop='Select Occurrence Type'
                                                                        selectName="othersOccurrenceType"
                                                                        options={[
                                                                            { name: 'Personal Injury', id: 'Personal Injury' },
                                                                            { name: 'Unsafe Act', id: 'Unsafe Act' },
                                                                            { name: 'Unsafe Condition', id: 'Unsafe Condition' },
                                                                            { name: 'Environmental Hazard', id: 'Environmental Hazard' },
                                                                            { name: 'Other', id: 'Other' },
                                                                        ]}
                                                                        value={values.othersOccurrenceType}
                                                                        onChange={(selectedOption) => setFieldValue("othersOccurrenceType", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.othersOccurrenceType && touched.othersOccurrenceType && (
                                                                        <p className="errormsg">{errors.othersOccurrenceType}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            {values.othersOccurrenceType == 'Other' && <>
                                                                <Col md={6}>
                                                                    <div className="form-group">
                                                                        <label>Other Details</label>
                                                                        <textarea
                                                                            id="othersDetails"
                                                                            name="othersDetails"
                                                                            className="form-control"
                                                                            value={values.othersDetails}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {errors.othersDetails && touched.othersDetails && (
                                                                            <p className="errormsg">{errors.othersDetails}</p>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <div className="form-group">
                                                                        <label>Other Location</label>
                                                                        <textarea
                                                                            id="othersLocation"
                                                                            name="othersLocation"
                                                                            className="form-control"
                                                                            value={values.othersLocation}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                        {errors.othersLocation && touched.othersLocation && (
                                                                            <p className="errormsg">{errors.othersLocation}</p>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            </>}
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Action Taken</label>
                                                                    <textarea
                                                                        id="othersActionTaken"
                                                                        name="othersActionTaken"
                                                                        className="form-control"
                                                                        value={values.othersActionTaken}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.othersActionTaken && touched.othersActionTaken && (
                                                                        <p className="errormsg">{errors.othersActionTaken}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="AIRLINE" className="department" style={data.departmentname === 'AIRLINE' ? { display: 'block' } : { display: 'none' }}>
                                                <div className="fieldset">
                                                    <h1>AIRLINE</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Person name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="airlinePersonName"
                                                                        name="airlinePersonName"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.airlinePersonName}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.airlinePersonName && touched.airlinePersonName && (
                                                                        <p className="errormsg">{errors.airlinePersonName}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Aircraft Registration</label>
                                                                    <div className='selectwith_input'>
                                                                        <div className='selects'>
                                                                            <SelectFild
                                                                                Firstop="Select"
                                                                                selectName='airlineCode'
                                                                                options={aircraftRegistration}
                                                                                value={values.airlineCode}
                                                                                onChange={(selectedOption) => setFieldValue("airlineCode", selectedOption?.value || "")}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="airlineFlightNumber"
                                                                            value={values.airlineFlightNumber}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                    </div>
                                                                    {errors.airlineCode && touched.airlineCode && (
                                                                        <p className="errormsg">{errors.airlineCode}</p>
                                                                    )}
                                                                    {errors.airlineFlightNumber && touched.airlineFlightNumber && (
                                                                        <p className="errormsg">{errors.airlineFlightNumber}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Aircraft Type</label>
                                                                    <SelectFild
                                                                        Firstop="Select Aircraft Type"
                                                                        selectName='airlineAircraftType'
                                                                        options={aircraftTypes}
                                                                        value={values.airlineAircraftType}
                                                                        onChange={(selectedOption) => setFieldValue("airlineAircraftType", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.airlineAircraftType && touched.airlineAircraftType && (
                                                                        <p className="errormsg">{errors.airlineAircraftType}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Delay Reason</label>
                                                                    <input
                                                                        type="text"
                                                                        id="airlineDelayReason"
                                                                        name="airlineDelayReason"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        value={values.airlineDelayReason}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.airlineDelayReason && touched.airlineDelayReason && (
                                                                        <p className="errormsg">{errors.airlineDelayReason}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Arrival Time</label>
                                                                    <TimeFild
                                                                        value={values.airlineArrivalTime}
                                                                        onChange={(time) => setFieldValue('airlineArrivalTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.airlineArrivalTime && touched.airlineArrivalTime && (
                                                                        <p className="errormsg">{errors.airlineArrivalTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Departure Time</label>
                                                                    <TimeFild
                                                                        value={values.airlineDepartureTime}
                                                                        onChange={(time) => setFieldValue('airlineDepartureTime', time)}
                                                                        format="local"
                                                                    />
                                                                    {errors.airlineDepartureTime && touched.airlineDepartureTime && (
                                                                        <p className="errormsg">{errors.airlineDepartureTime}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Gate Number</label>
                                                                    <input
                                                                        type="text"
                                                                        id="airlineGateNumber"
                                                                        name="airlineGateNumber"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        min="0"
                                                                        inputMode="numeric"
                                                                        pattern="[0-9]*"
                                                                        value={values.airlineGateNumber}
                                                                        onChange={(e) => {
                                                                            const onlyNums = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                                                            const syntheticEvent = {
                                                                                target: {
                                                                                    name: 'airlineGateNumber',
                                                                                    value: onlyNums,
                                                                                },
                                                                            };
                                                                            handleChange(syntheticEvent);
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.airlineGateNumber && touched.airlineGateNumber && (
                                                                        <p className="errormsg">{errors.airlineGateNumber}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Number of Passengers</label>
                                                                    <input
                                                                        type="text"
                                                                        id="airlineNumberofPassengers"
                                                                        name="airlineNumberofPassengers"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        min="0"
                                                                        inputMode="numeric"
                                                                        pattern="[0-9]*"
                                                                        value={values.airlineNumberofPassengers}
                                                                        onChange={(e) => {
                                                                            const onlyNums = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                                                            const syntheticEvent = {
                                                                                target: {
                                                                                    name: 'airlineNumberofPassengers',
                                                                                    value: onlyNums,
                                                                                },
                                                                            };
                                                                            handleChange(syntheticEvent);
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {errors.airlineNumberofPassengers && touched.airlineNumberofPassengers && (
                                                                        <p className="errormsg">{errors.airlineNumberofPassengers}</p>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className={preview == null ? 'GroupList fieldset' : 'GroupList fieldset opens'}>
                                        <div className='toggle-button'>
                                            <h2 className="listTitle">Description</h2>
                                            <div className='btnColaps'><FaChevronUp /></div>
                                        </div>
                                        <div className="formsBox subFilds Detailed">
                                            <div className="fieldset">
                                                <h1>Describe Image</h1>
                                                <div className="image_describe">
                                                    <div className="formsBox upload-container drop-zone"
                                                        onDrop={handleDrop}
                                                        onDragOver={handleDragOver}
                                                    >
                                                        <p>Drag & Drop Images Here</p>
                                                        <p>or</p>
                                                        <div type='button'
                                                            className="btn btn-orange"
                                                            onClick={() => document.getElementById('fileInput').click()}>
                                                            Select Files
                                                        </div>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            id="fileInput"
                                                            hidden
                                                            onChange={handleFileChange}
                                                        />
                                                    </div>
                                                    {preview != null && (
                                                        <div className="preview-grid">
                                                            <div className='imagesBoxs'>
                                                                <img src={preview} alt='Preview' />
                                                                <div className='removetbn' title="Remove" onClick={() => handleRemoveImage()}>
                                                                    <FaTrash />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className='button-boxs grid mt-3 mb-3'>
                                                        {preview != null && (
                                                            <>
                                                                <div className="btn btn-orange" onClick={analyzeImage}>
                                                                    AI Safety Genie Analyzes
                                                                </div>
                                                                {isShowBtn && (
                                                                    <div className="btn btn-red" onClick={() => setShowPopup(true)}>
                                                                        View Report
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}

                                                    </div>

                                                    {errors.detailedImage && touched.detailedImage ? (
                                                        <p className='errormsg'>{errors.detailedImage}</p>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <Row>
                                                <Col md={4} className='rd-100'>
                                                    <div className="form-group">
                                                        <label>Short Description <span className="req">*</span></label>
                                                        {editorReady && (
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={values.shortDescription}
                                                                config={{
                                                                    toolbar: ['undo', 'redo', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                                                                }}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setFieldValue('shortDescription', data);
                                                                }}
                                                            />
                                                        )}

                                                        {errors.shortDescription && touched.shortDescription ? (
                                                            <p className='errormsg'>{errors.shortDescription}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4} className='rd-100'>
                                                    <div className="form-group">
                                                        <label>Detailed Description <span className="req">*</span></label>
                                                        {editorReady && (
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={values.detailedDescription}
                                                                config={{
                                                                    toolbar: ['undo', 'redo', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                                                                }}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setFieldValue('detailedDescription', data);
                                                                }}
                                                            />
                                                        )}

                                                        {errors.detailedDescription && touched.detailedDescription ? (
                                                            <p className='errormsg'>{errors.detailedDescription}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4} className='rd-100'>
                                                    <div className="form-group">
                                                        <label>Immediate Actions Taken</label>
                                                        {editorReady && (
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={values.immediateActionsTaken}
                                                                config={{
                                                                    toolbar: ['undo', 'redo', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                                                                }}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setFieldValue('immediateActionsTaken', data);
                                                                }}
                                                            />
                                                        )}

                                                        {errors.immediateActionsTaken && touched.immediateActionsTaken ? (
                                                            <p className='errormsg'>{errors.immediateActionsTaken}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Reported On</label>
                                                        <DateFild
                                                            value={values.reportedOn}
                                                            onChange={(date) => setFieldValue('reportedOn', date)}
                                                        />
                                                        {errors.reportedOn && touched.reportedOn ? (
                                                            <p className='errormsg'>{errors.reportedOn}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Reported By</label>
                                                        <input
                                                            type='text'
                                                            id="reportedBy"
                                                            name="reportedBy"
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={values.reportedBy}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.reportedBy && touched.reportedBy ? (
                                                            <p className='errormsg'>{errors.reportedBy}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Created By</label>
                                                        <input
                                                            type='text'
                                                            id="createdBy"
                                                            name="createdBy"
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={values.createdBy}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.createdBy && touched.createdBy ? (
                                                            <p className='errormsg'>{errors.createdBy}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className='button-boxs grid'>
                                        <button type='submit' className='btn btn-orange'>Submit All</button>
                                    </div>
                                </form>

                                <Modal
                                    show={showModal}
                                    onHide={() => setShowModal(false)}
                                    size="lg"
                                    centered
                                    scrollable
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Select Location</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <input
                                            type="search"
                                            ref={searchInputRef}
                                            className="form-control mb-3"
                                            placeholder="Search location Here..."
                                        />
                                        <div ref={mapRef} style={{ width: "100%", height: "400px", borderRadius: "8px" }}></div>
                                        <p className="mt-3"><strong>Latitude:</strong> {latLng.lat}</p>
                                        <p><strong>Longitude:</strong> {latLng.lng}</p>
                                        <p><strong>Address:</strong> {address}</p>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn btn-red" onClick={() => setShowModal(false)}>
                                            Save & Close
                                        </button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal show={isShowPopup} onHide={() => setShowPopup(false)} size="lg" centered scrollable>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Report :-  {data?.reportNumber}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <AircraftIncidentReport
                                            ref={reportRef}
                                            reportData={reportData}
                                            setReportData={setReportData}
                                            localDate={dayjs().format('DD/MM/YYYY')}
                                            localTime={localTime}
                                            utcDate={getDefaultUTCDate()}
                                            utcTime={localTime}

                                            airpotname={data?.airpotname}
                                            subIncidentArea={values.subIncidentArea}
                                            lat={latLng.lat?.toFixed(6)}
                                            lng={latLng.lng?.toFixed(6)}

                                            riskAsessmentColor={riskAsessmentColor}
                                        />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button
                                            className="btn btn-red"
                                            onClick={handleSaveAndClose}
                                        >
                                            Save & Close
                                        </button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </Container>
                    }
                </div>
            </section>
            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default NewCase;

